import { render, staticRenderFns } from "./index.vue?vue&type=template&id=22fe9da7&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=22fe9da7&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fe9da7",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Providers/index.vue
// module id = 2454
// module chunks = 31